import { createSignal } from 'solid-js'
import { useService } from 'solid-services'
import { useMessageMention } from '../../../state/mentions/useMentions'
import { useChannel } from './useChannel'

export function useUi() {
  const { channelQuery } = useService(useChannel)()
  const { messageMentionChannelMap } = useService(useMessageMention)()
  const [isMentionOpen, setIsMentionOpen] = createSignal(false)
  const [ready, setReady] = createSignal<boolean>()

  const channelPathRoot = () => {
    return channelQuery?.data?.name === 'trade-leaders'
      ? '/chat'
      : `/chat/${channelQuery?.data?.name}`
  }

  const channelMessageMentions = () => {
    return channelQuery?.data?.id
      ? messageMentionChannelMap()[channelQuery?.data?.id]
      : []
  }

  return {
    isMentionOpen,
    setIsMentionOpen,
    channelPathRoot,
    channelMessageMentions,
    ready,
    setReady,
  }
}
